<template>
  <div>
    <h6 style="margin-bottom:20px">
      <b>Registro de usuario</b>
    </h6>
    
    <v-layout
      row
      wrap
      style="background-color: #fff; padding: 24px;">
      
      <v-flex xs12 row>
        

        <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
           <v-layout
            row
            wrap
            style="background-color: #fff; padding: 0px;">         
          <v-flex xs5
            style="padding: 8px">
            <v-text-field
              v-model="myUser.attributes.rut"
              style="margin-top:10px"
              label="Rut*"
              required
              placeholder="Cédula"
              @keypress="isRutValid($event)"
              :rules="[rules.required, rules.affair,rules.rut]"
              counter="20">
            </v-text-field>
          </v-flex>
          <v-flex
            xs1
            style="padding: 8px;">
          </v-flex>
           <v-flex
            xs5
            style="padding: 0px;margin-top:13px">
            <v-text-field
              v-model="myUser.attributes.email"
              label="Correo electrónico*"
              required
              placeholder="Correo electrónico"
              :rules="[rules.required, rules.email, rules.affair]"
              counter="50"></v-text-field>
          </v-flex>
          
          <v-flex
            xs5
            style="padding: 8px">
            <v-text-field
              v-model="myUser.attributes.user_info_attributes.name"
              label="Nombre*"
              required
              placeholder="Nombre"
              :rules="[rules.required, rules.name]"
              counter="25"></v-text-field>
          </v-flex>
           <v-flex
            xs1
            style="padding: 8px">
          </v-flex>
          <v-flex
            xs5
            style="padding: 8px 0px">
            <v-text-field
              v-model="myUser.attributes.user_info_attributes.last_name"
              label="Apellidos*"
              required
              placeholder="Apellidos"
              :rules="[rules.required, rules.name]"
              counter="25"></v-text-field>
          </v-flex>
          <v-flex
            xs5
            style="padding: 8px">
            <v-text-field
              v-model="myUser.attributes.mobile"
              label="Teléfono"
              type="number"
              required
              placeholder="Teléfono"
              :rules="[rules.phone]"
              counter="25"></v-text-field>
          </v-flex>
           <v-flex
            xs1
            style="padding: 8px">
          </v-flex>
          <v-flex
            xs5
            style="padding: 8px 0px">
             <v-select 
            
            label="Género*"
            placeholder="Genero"
            :items="['Masculino','Femenino','Otro']"
            v-model="myUser.attributes.user_info_attributes.gender"
            :rules="[rules.required]"
            ></v-select>

          </v-flex>
          <v-flex xs5>
            <v-select 
            style="margin-top:15px; padding: 8px"
            label="Locación*"
            :items="locationArray"
            item-text='name'
            item-value='id'
            v-model="myUser.attributes.user_info_attributes.location_id"
            :rules="[rules.required]"
            ></v-select>
          </v-flex >
        <v-flex
            xs1
            style="padding: 8px">
        </v-flex>
        <v-flex xs5>
            <v-text-field
              v-model="myUser.attributes.user_info_attributes.birthday"
              @clear="myUser.attributes.user_info_attributes.birthday=null"
              style="margin-top:10px;color:gray !important"
              label="Fecha de nacimiento"
              placeholder="Ingresa fecha de nacimiento"
              :rules="[rules.date]"
              type="date">
            </v-text-field>
            
        </v-flex >
        <v-flex xs5 style="padding: 0px 8px">
            <v-text-field
              v-model="myUser.attributes.password"
              style="margin-top:10px"
              label="Nueva contraseña del usuario*"
              required
              placeholder="Dígita una contraseña"
              :rules="[rules.required,rules.password]"
              type="password">
            </v-text-field>
          </v-flex >
           <v-flex
            xs1
            style="padding: 8px">
          </v-flex>
          <v-flex xs5>
            <v-text-field
              v-if="myUser.attributes.password.length>=6"
              v-model="myUser.attributes.password_confirmation"
              style="margin-top:10px"
              label="Confirmar nueva contraseña*"
              required
              placeholder="Repite tu contraseña"
              :rules="[rules.required,rules.confirm_password]"
              type="password">
            </v-text-field>
          </v-flex >
          
          <!-- <v-flex
            xs12
            style="padding: 8px">
            {{counter}}
          </v-flex> -->
          <!-- <v-flex
            xs12
            style="padding: 8px">
            <v-text-field
              v-model="counter.attributes.title"
              label="Título"
              placeholder="Máximo 70 caracteres"
              :rules="[rules.title]"
              counter="70"></v-text-field>
          </v-flex>
          <v-flex
            xs8
            style="padding: 8px">
            <v-textarea
              style="border:1px dashed #1976d2;padding:30px 20px 5px 10px "
              v-model="counter.attributes.message"
              label="Mensaje*"
              :auto-grow="true"
              rows="1"
              outlined
              placeholder="Escribe el contenido del mensaje"
              :rules="[rules.required, rules.message]"></v-textarea>
          </v-flex>-->
        </v-layout>
        </v-form> 
      </v-flex>

      
      
      <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex" >
          <v-btn
            type="button"
            outline
            color="red"
            style="width: 20%"
            @click="$router.push({name: 'counter_index'})"
            >Volver</v-btn>
        </v-flex>
        <v-flex xs6 offset-xs6>
          <v-btn
            type="button"
            outline
            color="#353545"
            :style="'margin-top:-66px'"
            style="width: 100%"
            @click="sendUser()"
            :disabled="!valid || !myUser.attributes.user_info_attributes.name|| !myUser.attributes.user_info_attributes.last_name|| !myUser.attributes.email|| !myUser.attributes.rut ||
                       !myUser.attributes.user_info_attributes.location_id|| !myUser.attributes.password|| !myUser.attributes.password_confirmation|| !myUser.attributes.user_info_attributes.gender">
            Enviar y guardar Usuario
            </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data(){
    return{
      myUser: {
        attributes: {
          email:'',
          rut:'',
          mobile:'',
          password:'',
          password_confirmation:'',
          user_info_type:'Client',
          user_info_attributes:{
            name:'',
            last_name: '',
            nationality:'',
            gender:'',
            birthday:'',
            picture:'',
            location_id:null
          },
        }
      },
      locationArray:[],
      confirmPassword:'',
      rules: {
          required: value => (value&&value.length>0) || 'Este campo es obligatorio',
          name: value =>{
            if(value.length>=3){
                return  value.length <= 25 || 'Máximo 25 caracteres'
            }else{
                return value.length >= 3  || 'Mínimo 3 caracteres'
            }}, 
          affair: value => value.length <= 50 || 'Máximo 50 caracteres',
          email: value => {
                if(value.length > 0) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'E-mail incorrecto';
                }
            },
          rut: value => {
                if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de Rut incorrecto'}else{return 'El Rut debe tener al menos 7 caracteres'}},
          phone: value => { if(value.length==0){return true}
                            else if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de teléfono incorrecto'}else{return 'El teléfono debe tener al menos 7 caracteres'}},
          password: value => (value.length <= 50 && value.length>=6) || 'La contraseña debe tener al menos 6 dígitos',
          confirm_password: value => ( (value.length <= 50 && value.length>=6)&& value==this.myUser.attributes.password) || 'Las contraseñas no coinciden',
          date: value => {let a=new Date(value);if(a.toDateString()!="Invalid Date"){return true} else{return 'La fecha no tiene un formato correcto'}},
      },
      valid: false
    }
  },
  created() {
    var vm=this;
    const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
            }
        })
        .then(function(response){
            console.log("ANSWER")
            console.log(response)
            let locations = response.body.data
           
            this.locationArray=locations.map(function(elem) {
                return {id: elem.id,name: elem.attributes.name};
            })
            console.log(this.locationArray);
            vm.myUser.attributes.user_info_attributes.location_id=localStorage.getItem("location_id")
        }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                    this.checkToken(response.body.meta.authentication_token)
                }
            }

        })
    } catch (e) {
      if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
        vm.updateAlertMessage(e.message)
        vm.updateIsInAlert(true)
      }else{
        if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
          vm.updateAlertMessage(e.message)
          vm.updateIsInAlert(true)
        }else{
          if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
            vm.updateAlertMessage(e.message)
            vm.updateIsInAlert(true)
          }else{
            alert(e.message)
          }
        }
      }
    }
  },
  computed: {
  },
  methods: {
    isRutValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && evt.key.toUpperCase()!="K") {
            evt.preventDefault();;
        } else {
            return true;
        }
    }, 
    
    sendUser(){
      String.prototype.capitalize = function() {
        return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
      };
      this.myUser.attributes.user_info_attributes.name=this.myUser.attributes.user_info_attributes.name.capitalize()
      this.myUser.attributes.user_info_attributes.last_name=this.myUser.attributes.user_info_attributes.last_name.capitalize()
      this.myUser.attributes.rut=this.myUser.attributes.rut.toUpperCase()
      // console.log("ENVIANDO COUNTER")
      // console.log(this.myUser)
      var vm=this;
      try {
        
        this.$http.post('users',{
          data: this.encrypt(this.myUser).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          console.log(response);
          this.$router.push({name: 'access_counter', params: {id: localStorage.getItem("location_id"), filter:false,date: new Date().toISOString().substr(0, 10),date2:new Date().toISOString().substr(0, 10),namex:localStorage.getItem("location_name")}})


          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          console.log(response);
        })
      } catch (e) {
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
          vm.updateAlertMessage(e.message)
          vm.updateIsInAlert(true)
        }else{
          alert(e.message)
        }
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/users/NewUser.vue